'use client';

import { clsx } from 'clsx';
import { useEffect, useRef, useState } from 'react';

import { useIntersectionObserver } from '@monoimin/hooks';

export const ScrollHandImage = ({
  isRichText,
  withTitle,
}: {
  isRichText: boolean;
  withTitle: boolean;
}) => {
  const [show, setShow] = useState(true);

  const imageRef = useRef<HTMLImageElement>(null);
  const entry = useIntersectionObserver(imageRef, {});
  const isIntersecting = !!entry?.isIntersecting;

  useEffect(() => {
    if (show && isIntersecting) {
      setTimeout(() => {
        setShow(false);
      }, 10000);
    }
  }, [isIntersecting]);

  return (
    <img
      ref={imageRef}
      src='/images/icons/hand.svg'
      alt=""
      className={clsx(
        'absolute h-10 w-10 object-contain md:hidden justify-self-center self-center transition-opacity duration-500',
        show ? 'opacity-100' : 'opacity-0',
        {
          '-right-1': isRichText,
          'right-5': !isRichText,
          '-top-10': !withTitle,
          'top-0': withTitle,
        }
      )}
    />
  );
};
